<template>
  <div class="list-box">
    <div v-for="(item,index) in list" :key="index" class="customCard list-for">
      <div
          class="item-title">
        {{ $language === 'ZH' ? item.title : item.titleEn }}
      </div>
      <div class="item-info">
        <div
            class="item-text">
          <div>{{ $language === 'ZH' ? item.company : item.companyEn }}</div>
          <div>{{ $language === 'ZH' ? item.name : item.nameEn }}</div>
          <div>{{ $t('h.callingCard.label1') + item.phone }}</div>
          <div>{{ $t('h.callingCard.label2') + item.email }}</div>
          <div v-if="$language === 'ZH' || item.mobile">{{ $t('h.callingCard.label3') + item.mobile }}</div>
        </div>
        <img v-if="item.qrcode" class="item-image"
             :src="item.qrcode"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Linkage",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss">
.list-box {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;

  .list-for {
    width: 100%;
    height: 300px;
    background: #F5F5F5;
    display: flex;
    flex-direction: column;

    .item-title {
      font-size: 24px;
      color: #212121;
      padding: 40px 40px 10px 40px;
    }

    .item-info {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .item-text {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        color: #444444;
        line-height: 28px;
        padding: 10px 0 40px 40px;
      }

      .item-image {
        width: 108px;
        height: 108px;
        margin-right: 40px;
        margin-bottom: 45px;
      }
    }
  }
}
</style>
